import { digitainConstants, configConstants } from '../actions/constants';
import { produce } from 'immer';
import { debug } from '../../utils';

const initialState = {
	loaded: false,
	loadState: true,
	betAbbr: {
		live: {},
		prematch: {}
	},
	betDesc: {
		live: {},
		prematch: {}
	},
	outcomeAbbr: {
		live: {},
		prematch: {}
	},
	entityTags: {
		live: {},
		prematch: {}
	},
	highlights: {},
	hotDays: [],
	teamsLogo: {},
	sportsOrder: {
		live: [],
		prematch: []
	},
	settings: {
		collapsableShowDefault: 2,
		collapsableShowMore: 5,
		twoDecimals: 20,
		oneDecimal: 50
	},
	homepageWinnerPlus: [],
	homepageWinnerAdv: [],
	homepagePromoted: [],
	homepageWinnerAdvCarousel: [],
	homepageLeagues: [],
	homepageNews: [],
	homepageSports: [],
	homepagePromotedBySports: {},
	liveTopLeagues: [],
	homepageGroups: {
		promoted: [],
		match_carousel: [],
		winner_avantaj: [],
		winner_selection: [],
		surprise_match: []
	},
	homepageGroupsImages: {},
	bonusRules: {},
	winnerFunCampaigns: [],
	navElements: [],
	digitainBonusRules: null,
};

const parseRules = rs => {
	//debug("config bonusRules", rs);

	const rules = {};

	Object.entries(rs).forEach(([c, bo]) => {
		rules[c] = {};

		Object.entries(bo).forEach(([bId, rs]) => {
			rules[c][bId] = rs.map(r => {
				//let code = "\"use strict\"; return(function(ticket, bonus, lists) {"+r.definition+"})";

				let code = '"use strict"; return ' + r.definition;

				//debug(code);

				r['script'] = window.Function(code)();
				return r;
			});
		});
	});

	//debug("-> resulted rules: ", rules);

	return rules;
};

const configReducer = (state = initialState, action) =>
	produce(state, draft => {
		switch (action.type) {
			case configConstants.LOADED: {
				//console.log("received config", action.data);

				draft.loaded = true;
				draft.loadState = false;

				draft.betAbbr = action.data.betAbbr;
				draft.betDesc = action.data.betDesc;
				draft.outcomeAbbr = action.data.outcomeAbbr;
				draft.entityTags = action.data.entityTags;
				draft.highlights = action.data.highlights;
				draft.hotDays = action.data.hotDays;
				draft.teamsLogo = action.data.teamsLogo;
				draft.sportsOrder = action.data.sportsOrder;
				draft.settings = action.data.settings;
				draft.homepageWinnerAdv = action.data.homepageWinnerAdv;
				draft.homepageWinnerPlus = action.data.homepageWinnerPlus;
				draft.homepagePromoted = action.data.homepagePromoted;
				draft.homepageWinnerAdvCarousel = action.data.homepageWinnerAdvCarousel;
				draft.homepageLeagues = action.data.homepageLeagues;
				draft.homepageNews = action.data.homepageNews;
				draft.homepageSports = action.data.homepageSports;
				draft.homepagePromotedBySports = action.data.homepagePromotedBySports;
				draft.liveTopLeagues = action.data.liveTopLeagues;
				draft.homepageGroups = action.data.homepageGroups;
				draft.homepageGroupsImages = action.data.homepageGroupsImages;

				if (action.data.navElements) draft.navElements = action.data.navElements;

				if (action.data.winnerFun && action.data.winnerFun.seasons && action.data.winnerFun.seasons.length !== 0) {
					const campaigns = [];
					action.data.winnerFun.seasons.forEach(s => {
						if (s.id && s.type && s.startDate && s.endDate) {
							campaigns.push({ id: s.id, type: s.type, start_date: s.startDate, end_date: s.endDate, name: s.name, icon: s.icon, pointsMultiplier: s.pointsMultiplier });
						}

						if (s.events && s.events.length !== 0) {
							s.events.forEach(e => {
								if (e.id && e.type && e.startDate && e.endDate) {
									campaigns.push({ id: e.id, type: e.type, start_date: e.startDate, end_date: e.endDate, name: e.name, icon: e.icon, pointsMultiplier: e.pointsMultiplier, filters: e.filters, min_odd_cap: e.min_odd_cap, max_odd_cap: e.max_odd_cap });
								}
							});
						}
					});
					draft.winnerFunCampaigns = campaigns;
				}

				if (action.data.bonusRules) {
					draft.bonusRules = parseRules(action.data.bonusRules);
				}

				break;
			}
			case configConstants.RELOAD: {
				draft.loaded = false;
				break;
			}
			case configConstants.UPDATE: {
				Object.keys(action.data).forEach(k => {
					if (k === 'bonusRules') {
						draft[k] = parseRules(action.data[k]);
					} else {
						draft[k] = action.data[k];
					}
				});
				break;
			}
			case digitainConstants.SET_BONUS_RULES: {
				draft.digitainBonusRules = action.data;
				break;
			}
			default:
			/* noop */
		}
	});

export default configReducer;
